<template lang="pug">
.select-tab
  .columns
    .column.flex-basis-75
      .plan-wrapper
        ZoomableSvg(
          ref="zoomableSvg"
          v-model="selectedSeats"
          svg-url="/poc_map.svg"
          selectionColor="var(--color--primary)"
          :initial-category="product ? product.category : 'K1'"
          :unavailable-ids="unavailableIds"
          :max-count="count"
        )
    .column.flex-basis-25
      .headline-container.base-headline-container
        button.btn.is--inverted.is--secondary(v-if="selectedSeats.length === 0" type="button" @click="$refs.zoomableSvg.selectBestGroup(count)") Bestplatzbuchung
        button.btn.is--tertiary.is--icon.is--remove(type="button" @click="$refs.zoomableSvg.clearSelection()" v-else)
          svg( height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg")
            path(fill="#fff" d="M7.3077 20.5C6.80898 20.5 6.38302 20.3234 6.02982 19.9701C5.67661 19.6169 5.5 19.191 5.5 18.6923V5.99999H4.5V4.50002H8.99997V3.61542H15V4.50002H19.5V5.99999H18.5V18.6923C18.5 19.1974 18.325 19.625 17.975 19.975C17.625 20.325 17.1974 20.5 16.6922 20.5H7.3077ZM17 5.99999H6.99997V18.6923C6.99997 18.782 7.02882 18.8557 7.08652 18.9134C7.14422 18.9711 7.21795 19 7.3077 19H16.6922C16.7692 19 16.8397 18.9679 16.9038 18.9038C16.9679 18.8397 17 18.7692 17 18.6923V5.99999ZM9.40385 17H10.9038V7.99999H9.40385V17ZM13.0961 17H14.5961V7.99999H13.0961V17Z")
        h3(style="display: inline;") {{selectedSeats.length}} / {{count}}
      span(v-if="selectedSeats.length === 0") Bitte Sitzplätze auswählen
      .ticket(v-for="id in selectedSeats")
        .headline-container
          h5 Platz {{ id.split("-")[1] }}
          button.btn.is--tertiary.is--icon.is--remove(type="button" @click="$refs.zoomableSvg.deselectElementById(id)")
            svg(fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg")
              path(d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12Z")
        ul.no-list-style
          li.icon-text
            svg(fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg")
              path(d="M2 7H22V10H20L21 19H18.5L17.94 14H6.06L5.5 19H3L4 10H2V7M17.5 10H6.5L6.29 12H17.71L17.5 10Z" fill="#000")
            span.icon-text-content
              p Tisch {{id.split("-")[0]}}
          li.icon-text
            svg(fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg")
              path(d="M19,1L17.74,3.75L15,5L17.74,6.26L19,9L20.25,6.26L23,5L20.25,3.75M9,4L6.5,9.5L1,12L6.5,14.5L9,20L11.5,14.5L17,12L11.5,9.5M19,15L17.74,17.74L15,19L17.74,20.25L19,23L20.25,20.25L23,19L20.25,17.74" fill="#000")
            span.icon-text-content
              p(v-if="product") {{product.category_title}}
          li.icon-text
            svg(fill="none" height="24" viewBox="0 0 24 24" width="24" xmlns="http://www.w3.org/2000/svg")
              path(d="M12 12H17V17H12V12M19 3H18V1H16V3H8V1H6V3H5C3.9 3 3 3.9 3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3M19 5V7H5V5H19M5 19V9H19V19H5Z" fill="#000")
            span.icon-text-content
              p(v-if="product") {{product.week_day}}, {{product.date_string}}
</template>

<script>

import ZoomableSvg from './components/ZoomableSvg.vue'
export default {
  components: { ZoomableSvg },
  props: [
    "product",
    "step",
    "count"
  ],
  data () {
    return {
      selectedSeats: [],
      countInput: null,
      unavailableIds: ['21-3', '21-7']
    }
  },
  mounted () {
  },
  watch: {
    selectedSeats(){
      if (this.step == 2) this.$emit('update:buttonDisabled', this.selectedSeats.length != this.count)
    },
    step(){
      if (this.step == 1) this.$refs.zoomableSvg.clearSelection()
      if (this.step == 2) {
        this.$emit('update:buttonDisabled', this.selectedSeats.length != this.count)
      } else {
        this.$emit('update:buttonDisabled', false)
      }
    }
  },
  computed: {
  },
  methods: {
  }
}
</script>
